import { useReadDocuments } from '@/api/accounting-dealer/file'
import { DocumentInput } from '@/components/document-input'

import { DocumentType, ReadDealResponse } from '@/types'
import { FieldPath } from 'react-hook-form'
import { DocumentsSchemaType } from './schema'
import { useCallback } from 'react'
import { useOutletContext } from 'react-router-dom'

type PartnerDocumentsProps = {
  partnerKey: string
  partnerIndex?: number
  isMainPartner?: boolean
}

export const PartnerDocuments = ({
  partnerKey,
  partnerIndex,
  isMainPartner = false,
}: PartnerDocumentsProps) => {
  const { deal } = useOutletContext<ReadDealResponse>()

  const isChangeAccountant = deal.company.status === 'changing_accountant'

  const { data: documents } = useReadDocuments({
    entity_key: partnerKey,
    entity_type: 'partner',
  })

  const getFieldName = useCallback(
    (docType: DocumentType): FieldPath<DocumentsSchemaType> => {
      if (isMainPartner) {
        return `mainPartner.${docType}` as FieldPath<DocumentsSchemaType>
      }
      return `otherPartners[${partnerIndex}].${docType}` as FieldPath<DocumentsSchemaType>
    },
    [isMainPartner, partnerIndex],
  )

  return (
    <>
      <DocumentInput
        fieldName={getFieldName('personal')}
        entity={{ key: partnerKey, type: 'partner' }}
        documents={documents || []}
        documentType="personal"
        required
      />
      <DocumentInput
        fieldName={getFieldName('address')}
        entity={{ key: partnerKey, type: 'partner' }}
        documents={documents || []}
        documentType="address"
        required
      />
      {isChangeAccountant && (
        <DocumentInput
          fieldName={getFieldName('professional_council_membership_card')}
          entity={{ key: partnerKey, type: 'partner' }}
          documents={documents || []}
          documentType="professional_council_membership_card"
          required
        />
      )}
    </>
  )
}
